import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ContentChildren, EventEmitter, Inject, OnInit, Output, QueryList } from '@angular/core';
import { EventTrackerService } from '@app/core';

import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'navaar-tabs-scroll-spy',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})

export class TabsComponent implements OnInit, AfterViewInit {
  @Output('clicked-tab') private clickedTab: EventEmitter<{ title: string, enTitle: string, isActive: boolean }> = new EventEmitter<{ title: string, enTitle: string, isActive: boolean }>();

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  public currentSection: string;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,    
    private readonly eventTracker: EventTrackerService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.currentSection = this.tabs.first.id;
  }

  public onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  public scrollTo(section) {
    document.querySelector('#' + section).scrollIntoView({ behavior: "smooth" });
  }

  selectTab(tab: TabComponent, selectedByUser: boolean) {
    this.clickedTab.emit({
      title: tab.title,
      enTitle: tab.enTitle,
      isActive: tab.active
    });
  }
}
